import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NaviService } from '../../services/navi.service';
import { RegisterService } from '../../services/register.service';

import { BasicError } from '../../models/error/error';
declare var $: any;

@Component({
  selector: 'app-set-new-password',
  templateUrl: './set-new-password.component.html',
  styleUrls: ['./set-new-password.component.css']
})
export class SetNewPasswordComponent implements OnInit, AfterViewInit {
  public loginUrl: String = 'login';

  public token: String = '';

  public isReseted: Boolean = true;

  public inpPassword: String = '';
  public inpPasswordConf: String = '';

  public resetedSuc: Boolean = false;

  public infoOutput: String = '';
  public alertInfo: Boolean = false;

  constructor(private naviService: NaviService, private registerService: RegisterService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.token = this.route.snapshot.queryParams['token'];
  }

  ngAfterViewInit() {
    const self = this;

    $(document).ready(function () {
      $('#newpassword1, #newpassword2').on('keydown', function (e) {
        if (e.which === 13) {
          self.setNewPassword();
        }
      });
    });

  } // ngAfterView end


  public setNewPassword() {
    if (this.inpPassword !== '' && this.inpPasswordConf !== '' && this.inpPassword === this.inpPasswordConf &&
      this.inpPassword.length >= 8 && (this.token !== undefined || this.token !== null)) {
      this.registerService.setNewPassword(this.inpPassword, this.inpPasswordConf, this.token).subscribe(data => {
        if (data instanceof BasicError) {
          console.log(data);
          this.infoOutput = 'Es ist ein Fehler aufgetreten!';
          this.alertInfo = true;
          this.isReseted = false;
          this.resetedSuc = false;
        } else {
          this.infoOutput = 'Sie haben das Passwort erfolgreich geändert.';
          this.alertInfo = true;
          this.isReseted = true;
          this.resetedSuc = true;
        }
      });

    } else {
      if (this.inpPassword.length < 8) {
        this.infoOutput = 'Das Passwort muss mind. 8 Zeichen enthalten!';
        this.alertInfo = true;
      } else if (this.inpPassword === '' || this.inpPasswordConf === '') {
        this.infoOutput = 'Bitte füllen Sie alle Felder aus!';
        this.alertInfo = true;
      } else if (this.inpPassword !== this.inpPasswordConf) {
        this.infoOutput = 'Die Passwörter müssen übereinstimmen!';
        this.alertInfo = true;
      } else {
        this.infoOutput = 'Es ist ein unbekannter Fehler aufgetreten!';
        this.alertInfo = true;
      }
    }
  }

  public navigateToLogin() {
    this.naviService.navigateToUrl(this.loginUrl, 'login');
  }
}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/set-new-password/set-new-password.component.ts